<div class="container-fluid mt-3 mb-5">
  <!-- Page Header -->
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="mb-0 fw-bold">
      Awarded Contracts
      <span *ngIf="totalPageItems" class="badge bg-primary-subtle text-primary ms-2 fw-semibold"
        style="font-size: 0.75rem;">{{ totalPageItems }}</span>
    </h5>
    <button class="btn btn-outline-primary btn-sm text-nowrap" type="button" (click)="exportExcel()" [disabled]="exporting">
      <i class="fas" [ngClass]="{'fa-spinner fa-spin': exporting, 'fa-file-excel': !exporting}"></i>
      Export
    </button>
  </div>

  <!-- Statistics -->
  <div class="card border-0 shadow-sm mb-3" *ngIf="stats">
    <!-- Mobile collapse toggle -->
    <button type="button" class="stats-toggle d-lg-none" (click)="statsOpen = !statsOpen"
      [attr.aria-expanded]="statsOpen">
      <span class="fw-semibold"><i class="fas fa-chart-pie me-2 text-muted"></i>Summary</span>
      <span class="text-muted small d-flex align-items-center gap-2">
        {{ stats.total | number }} contracts
        <i class="fas" [ngClass]="statsOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </span>
    </button>
    <div class="card-body p-3 stats-body" [class.stats-collapsed]="!statsOpen">
      <div class="row g-3 align-items-center stats-row">
        <div class="col-6 col-md-4 col-xl stats-tile">
          <div class="text-center">
            <div class="text-muted small text-uppercase fw-semibold mb-1">Total</div>
            <div class="fs-3 fw-bold text-dark">{{ stats.total | number }}</div>
            <div class="text-muted small">contracts</div>
          </div>
        </div>
        <div class="col-6 col-md-4 col-xl border-start stats-tile">
          <div class="text-center">
            <div class="text-muted small text-uppercase fw-semibold mb-1">Active</div>
            <div class="fs-3 fw-bold text-dark">{{ stats.active | number }}</div>
            <div class="text-muted small">in progress</div>
          </div>
        </div>
        <div class="col-6 col-md-4 col-xl border-start stats-tile">
          <div class="text-center">
            <div class="text-muted small text-uppercase fw-semibold mb-1">Not Started</div>
            <div class="fs-3 fw-bold text-dark">{{ stats.not_started | number }}</div>
            <div class="text-muted small">upcoming</div>
          </div>
        </div>
        <div class="col-6 col-md-4 col-xl border-start stats-tile">
          <div class="text-center">
            <div class="text-muted small text-uppercase fw-semibold mb-1">Ended</div>
            <div class="fs-3 fw-bold text-dark">{{ stats.ended | number }}</div>
            <div class="text-muted small">completed</div>
          </div>
        </div>
        <div class="col-6 col-md-4 col-xl border-start stats-tile stats-tile--wide">
          <div class="text-center">
            <div class="text-muted small text-uppercase fw-semibold mb-1">Volume</div>
            <div class="fs-5 fw-bold text-dark">{{ stats.total_volume | number:'1.0-0' }}</div>
            <div class="text-muted small">contract volume</div>
          </div>
        </div>
        <div class="col-6 col-md-4 col-xl border-start stats-tile">
          <div class="text-center">
            <div class="text-muted small text-uppercase fw-semibold mb-1">Suppliers</div>
            <div class="fs-5 fw-bold text-dark">{{ stats.unique_suppliers | number }}</div>
            <div class="text-muted small">unique</div>
          </div>
        </div>
        <div class="col-6 col-md-4 col-xl border-start stats-tile">
          <div class="text-center">
            <div class="text-muted small text-uppercase fw-semibold mb-1">Locations</div>
            <div class="fs-5 fw-bold text-dark">{{ stats.unique_locations | number }}</div>
            <div class="text-muted small">unique</div>
          </div>
        </div>
        <div class="col-12 col-md-5 col-xl-auto border-start stats-chart">
          <div class="d-flex align-items-center gap-2">
            <apx-chart *ngIf="chartOptions"
              [series]="chartOptions.series"
              [chart]="chartOptions.chart"
              [labels]="chartOptions.labels"
              [colors]="chartOptions.colors"
              [plotOptions]="chartOptions.plotOptions"
              [dataLabels]="chartOptions.dataLabels"
              [legend]="chartOptions.legend"
              [responsive]="chartOptions.responsive"
            ></apx-chart>
            <div class="d-flex flex-column gap-1" *ngIf="chartOptions">
              <span class="chart-legend-item"><i class="fas fa-circle text-success me-1 chart-legend-dot"></i>Active</span>
              <span class="chart-legend-item"><i class="fas fa-circle text-primary me-1 chart-legend-dot"></i>Not Started</span>
              <span class="chart-legend-item"><i class="fas fa-circle text-secondary me-1 chart-legend-dot"></i>Ended</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters & Table -->
  <div class="bg-white border">
  <div class="filters-bar d-flex align-items-center flex-wrap gap-3 px-3 py-2 border-bottom">
    <div class="btn-group btn-group-sm status-tabs" role="group">
      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="filterStatus" (ngModelChange)="changeFilter('all')"
        type="radio" class="btn-check" name="all" id="btnradio1" autocomplete="off" checked>
      <label [ngClass]="{'btn-primary': filterStatus === 'all', 'btn-outline-primary': filterStatus !== 'all'}"
        class="btn btn-sm" for="btnradio1">All</label>

      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="filterStatus"
        (ngModelChange)="changeFilter('not_stared')" type="radio" class="btn-check" name="active" id="btnradio2"
        autocomplete="off">
      <label [ngClass]="{'btn-primary': filterStatus === 'not_stared', 'btn-outline-primary': filterStatus !== 'not_stared'}"
        class="btn btn-sm" for="btnradio2">Not Started</label>

      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="filterStatus"
        (ngModelChange)="changeFilter('active')" type="radio" class="btn-check" name="active" id="btnradio3"
        autocomplete="off">
      <label [ngClass]="{'btn-primary': filterStatus === 'active', 'btn-outline-primary': filterStatus !== 'active'}"
        class="btn btn-sm" for="btnradio3">Active</label>

      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="filterStatus"
        (ngModelChange)="changeFilter('ended')" type="radio" class="btn-check" name="ended" id="btnradio4"
        autocomplete="off">
      <label [ngClass]="{'btn-primary': filterStatus === 'ended', 'btn-outline-primary': filterStatus !== 'ended'}"
        class="btn btn-sm" for="btnradio4">Ended</label>
    </div>

    <div class="btn-group btn-group-sm" role="group">
      <div ngbDropdown class="d-inline-block">
        <button class="btn btn-sm btn-outline-secondary" ngbDropdownToggle type="button">
          <i class="far fa-calendar-alt me-1"></i>
          {{ datePresetLabel }}
        </button>
        <div ngbDropdownMenu>
          <button ngbDropdownItem *ngFor="let preset of datePresets" (click)="applyDatePreset(preset)"
            [class.active]="selectedPreset === preset.key">
            {{ preset.label }}
          </button>
        </div>
      </div>
      <button *ngIf="dateStart || dateEnd" class="btn btn-sm btn-outline-secondary" (click)="clearDateFilter()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <ng-container *ngIf="selectedPreset === 'custom'">
      <jft-datepicker (onChangeDate)="onDateStart($event)" (onTouchedDate)="onTouchedDate()"
        [placeholder]="'Start Date'" id="index_date_start">
      </jft-datepicker>
      <jft-datepicker (onChangeDate)="onDateEnd($event)" (onTouchedDate)="onTouchedDate()" [enabled]="!!dateStart"
        [placeholder]="'End Date'" id="index_date_end">
      </jft-datepicker>
    </ng-container>

    <div class="input-group input-group-sm ms-auto contracts-search" style="max-width: 300px;">
      <input [(ngModel)]="term" (ngModelChange)="search()" type="text" class="form-control"
        placeholder="Search by location, company, supplier..." />
      <button class="btn btn-outline-secondary" type="button" [disabled]="!term" (click)="clearTerm()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table contracts-table mb-0 align-middle">
      <thead>
        <tr>
          <th>
            <a (click)="sort($event, 'location')" class="pointer d-flex align-items-center">Location
              <i *ngIf="orderField === 'location' && order" class="fa ms-1"
                [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
            </a>
          </th>
          <th>Company</th>
          <th>
            <a (click)="sort($event, 'volume')" class="pointer d-flex align-items-center">Yearly Volume
              <i *ngIf="orderField === 'volume' && order" class="fa ms-1"
                [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
            </a>
          </th>
          <th>
            <a (click)="sort($event, 'date_start')" class="pointer d-flex align-items-center">Start
              <i *ngIf="orderField === 'date_start' && order" class="fa ms-1"
                [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
            </a>
          </th>
          <th>
            <a (click)="sort($event, 'date_end')" class="pointer d-flex align-items-center">End
              <i *ngIf="orderField === 'date_end' && order" class="fa ms-1"
                [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
            </a>
          </th>
          <th>
            <a (click)="sort($event, 'award_percentage')" class="pointer d-flex align-items-center">Award %
              <i *ngIf="orderField === 'award_percentage' && order" class="fa ms-1"
                [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
            </a>
          </th>
          <th>
            <a (click)="sort($event, 'supplier')" class="pointer d-flex align-items-center">Supplier
              <i *ngIf="orderField === 'supplier' && order" class="fa ms-1"
                [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
            </a>
          </th>
          <th>
            <a (click)="sort($event, 'tender')" class="pointer d-flex align-items-center">Tender / Round
              <i *ngIf="orderField === 'tender' && order" class="fa ms-1"
                [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let offer of awarded_offers">
          <td>
            <strong>{{ offer.contract.location.iata }}</strong>
          </td>
          <td data-label="Company">
            <span *ngIf="offer.contract.companyChild && offer.contract.companyChild?.name">{{ offer.contract.companyChild?.getDisplayName() }}</span>
            <span *ngIf="!(offer.contract.companyChild && offer.contract.companyChild?.name) && offer.contract.companyInfo">{{ offer.contract.companyInfo }}</span>
            <span *ngIf="!(offer.contract.companyChild && offer.contract.companyChild?.name) && !offer.contract.companyInfo" class="small text-muted">
              Not Provided
            </span>
          </td>
          <td data-label="Yearly Volume">
            {{ offer.contract.volume | number : '1.0-0' | usNumber }} {{ offer.contract.units.code }}
          </td>
          <td data-label="Start">
            {{ offer.contract.dateStart.toFormat(defaultDateFormat) }}
          </td>
          <td data-label="End">
            {{ offer.contract.dateEnd.toFormat(defaultDateFormat) }}
          </td>
          <td data-label="Award %">
            {{ offer.awardedPercent | number:'1.0-2' }}%
          </td>
          <td data-label="Supplier">
            <div class="d-flex align-items-center gap-2">
              <div *ngIf="offer.supplier.logo" class="flex-shrink-0 avatar avatar-32 bg-white rounded shadow-sm">
                <img src="{{ offer.supplier.logo }}" alt="{{ offer.supplier.name }}">
              </div>
              <div>
                {{ offer.supplier.name }}
                <span *ngIf="offer.supplier.supplierAlias" class="text-muted small"> ({{ offer.supplier.supplierAlias }})</span>
              </div>
            </div>
          </td>
          <td data-label="Tender / Round">
            <div class="small text-muted">{{ offer.contract.tender?.name }}</div>
            <div class="small text-muted"><jft-time-remaining [round]="offer.round"></jft-time-remaining></div>
          </td>
        </tr>

        <tr *ngIf="!awarded_offers.length" class="no-contracts-row">
          <td colspan="8">
            <p class="text-center small my-5">No contracts found</p>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="text-center p-3 border-top" *ngIf="awarded_offers.length < totalPageItems">
      <button class="btn btn-primary px-4" (click)="loadMore()" [disabled]="loadingMore">
        <span *ngIf="loadingMore" class="spinner-border spinner-border-sm me-2" role="status"></span>
        Load More
        <small class="ms-1 opacity-50">({{ awarded_offers.length }} of {{ totalPageItems }})</small>
      </button>
    </div>
  </div>
  </div>
</div>
